import { makeStyles } from '@material-ui/core/styles'
import { themeCommon } from '../../theme'

const useStyles = makeStyles((theme) => ({
    rootAccordion: {
        boxShadow: '0px 0px 2px 2px rgba(34, 35, 58, 0.2)',
    },
    roundedAccordion: {
        borderRadius: '0px 0px 0px 0px',
        '&:last-child': {
            borderBottomLeftRadius: '0px',
            borderBottomRightRadius: '0px',
        },
        '&:first-child': {
            borderTopLeftRadius: '0px',
            borderTopRightRadius: '0px',
        }
    },
    rootAccordionSummary: {
        padding: '0 !important',
    },
    expandedAccordionSummary: {
        minHeight: 'auto !important',
    },
    contentAccordionSummary: {
        margin: '0 !important',
    },
    rootTypographyTitle: {
        fontSize: themeCommon.fontSize14px,
        margin: '10px',
        fontFamily: themeCommon.RobotoBold,
        '-webkit-line-clamp': '1',
        display: '-webkit-box',
        '-webkit-box-orient': 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        [theme.breakpoints.down('md')]: {
            fontSize: themeCommon.fontSize13px,
            margin: '10px',
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: themeCommon.fontSize12px,
            margin: '5px',
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: themeCommon.fontSize10px,
            margin: '5px',
        },
    },
    image: {
        width: "100%", 
        height:"150px", 
        margin: "none", 
        objectFit: "cover",
        [theme.breakpoints.down('md')]: {
            height: "80px", 
        },
        [theme.breakpoints.down('sm')]: {
            height: "70px", 
        },
        [theme.breakpoints.down('xs')]: {
            height: "45px", 
        },
    },
}), {
    name: 'TopNewsHolder',
    index: 1,
})

export default useStyles